const TOKEN_KEY = 'wpc_h5_access_token'
const AUTH_META_KEY = 'wpc_h5_auth_meta'

export function getToken () {
  return sessionStorage.getItem(TOKEN_KEY) || ''
}

export function setToken (token) {
  sessionStorage.setItem(TOKEN_KEY, token || '')
}

export function getAuthMeta () {
  const raw = sessionStorage.getItem(AUTH_META_KEY)
  if (!raw) {
    return {}
  }
  try {
    return JSON.parse(raw) || {}
  } catch (e) {
    return {}
  }
}

export function setAuthMeta (meta) {
  sessionStorage.setItem(AUTH_META_KEY, JSON.stringify(meta || {}))
}

export function clearToken () {
  sessionStorage.removeItem(TOKEN_KEY)
}

export function clearAuthSession () {
  clearToken()
  sessionStorage.removeItem(AUTH_META_KEY)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js